const faqs = [
  {
    q: '吃瓜网51的内容来源可靠吗？',
    a: '吃瓜网51坚持多方验证原则，每条爆料内容发布前均经过至少两个独立信息源的交叉核实。同时我们标注了每条爆料的信源等级，方便读者自行判断可信度。对于未经充分验证的消息，会明确标注"待核实"标签。',
  },
  {
    q: '如何向吃瓜网51投稿爆料？',
    a: '你可以通过页面底部的投稿通道或直接发送邮件至我们的爆料邮箱提交信息。我们提供完全匿名投稿选项，严格保护爆料人隐私。投稿内容一经核实采用，我们将根据爆料价值提供相应稿酬奖励。',
  },
  {
    q: '吃瓜网51的更新频率是多少？',
    a: '吃瓜网51实行全天候运营模式，编辑团队7×24小时轮值。每天早中晚三个时段固定更新重点爆料专题，突发爆料事件更会实时推送。日均更新量超过200条，确保你永远不会错过任何热点。',
  },
  {
    q: '如何在手机上使用吃瓜网51？',
    a: '吃瓜网51提供适配移动端的网页版本，同时我们也有专属APP可供下载。APP端支持推送通知功能，重大爆料事件即时提醒。扫描页面底部二维码或访问应用商店搜索"吃瓜网51"即可下载。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">常见问答</h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}